<template>
<article v-if="isLoading || data" class="i-results__component">
    <loader v-if="isLoading" />
    <div v-if="data" class="i-results__content" ref="resizeBlock">
        <template v-for="(list, i) in dataSort" :key="i">
            <results-table @tab-change="tabChange" v-if="list.items?.length > 0" :results="list" :is-reverse="isReverse"/>
        </template>
        <button v-if="isListCompact && dataLength" type="button" class="i-results__show-more" @click.prevent="getMore">
            <svg width="16" height="20" viewBox="0 0 16 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M13.8618 5.16489L8.69922 6.15122L10.5315 3.45351C9.74664 3.14896 8.89311 2.9819 8 2.9819C4.13401 2.9819 1 6.11591 1 9.9819C1 10.9849 1.21064 11.9374 1.58963 12.7986L0.674342 13.2014C0.240559 12.2157 0 11.1262 0 9.9819C0 5.56363 3.58172 1.9819 8 1.9819C9.1011 1.9819 10.1508 2.2046 11.1061 2.60742L12.8755 0.00231934L13.8618 5.16489ZM15 9.9819C15 8.99196 14.7948 8.05124 14.4251 7.19895L15.3425 6.801C15.7657 7.77654 16 8.85251 16 9.9819C16 14.4002 12.4183 17.9819 8 17.9819C6.78562 17.9819 5.63369 17.711 4.60208 17.2264L2.82805 19.8499L1.83116 14.6894L6.9917 13.6925L5.17006 16.3864C6.03511 16.7693 6.99236 16.9819 8 16.9819C11.866 16.9819 15 13.8479 15 9.9819Z"
                    fill="black" />
            </svg>
            <span>
                Показать ещё
            </span>
        </button>
    </div>
</article>
</template>

<script>
import Loader from '../../vue-components/Loader'
import ResultsTable from './ResultsTable'

export default {
    name: 'ResultsTab',
    components: {
        Loader,
        ResultsTable
    },
    props: {
        isLoading: {
            type: Boolean,
            default: false
        },
        data: {
            type: Object,
            default: () => { }
        },
	    isReverse: {
		    type: Boolean,
		    default: false
	    }
    },
    data() {
        return {
            isListCompact: true,
            maxBlocks: 4,
        }
    },
    computed: {
        dataLength() {
            const sortDataWithItems = this.data.filter(el => el.items)
            return sortDataWithItems.length > this.maxBlocks
        },
        dataSort() {
            let sortData = this.data.slice(0, 4)
            if (this.data.length > this.maxBlocks && !this.isListCompact) {
                sortData = [...sortData, ...this.data.slice(4, this.data.length)]
            }
            return sortData
        },
    },
    methods: {
        getMore() {
            this.isListCompact = false
            setTimeout(() => {
                this.resizeContent()
            }, 0)
        },
        resizeContent() {
            if (this.$refs.resizeBlock) {
                this.$refs.resizeBlock.style.height = this.$refs.resizeBlock.scrollHeight + 'px'
            }
        },
        tabChange() {
            this.$nextTick(() => {
                this.resizeContent();
            })
        }
    },
    mounted() {
        setTimeout(() => {
            this.resizeContent();
        }, 1000);
    }
}
</script>